import React from 'react'

export default ({
    children,
    ...props
}) => {
    const prefix = 'vrtl-custom-mapping-fields'
    return (
        <div className={`${prefix}__heading-container`}>
            <div className={`${prefix}__section`}>Name</div>
            <div className={`${prefix}__section`}>Value</div>
            <div className={`${prefix}__icon-offset--2`} />
            {
                children
                    ? React.cloneElement(children, { ...props, className: `${prefix}__icon-add` })
                    : <div className={`${prefix}__icon-offset`} />
            }
        </div>
    )
}
